module.exports = __webpack_public_path__ + "static/media/shreya.dc275957.jpg";